import Vue from 'vue';
import VueX from 'vuex';
import createPersistedState from "vuex-persistedstate";

Vue.use(VueX);

import {auth} from './auth';

export const store = new VueX.Store({
  modules: {
    auth
  },
  plugins: [createPersistedState()]
});
